import GenerateContentWithAIForm, {
  GenerateContentWithAIFormProps,
  GenerateContentWithAISubmitProps,
} from "@/content/ai/GenerateContentWithAIForm"
import { GlobalID } from "@/relay/RelayTypes"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { displayErrorToast } from "@components/toast/ToastProvider"
import { TestIDProps } from "@utils/typeUtils"
import { observer } from "mobx-react-lite"

interface GenerateContentWithAIProps extends TestIDProps {
  onSubmit: GenerateContentWithAIFormProps["onSubmit"]
  moduleContentUsageId?: GlobalID
}

function GenerateContentWithAI({
  onSubmit,
  moduleContentUsageId,
}: GenerateContentWithAIProps) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <GenerateContentWithAIForm
        onSubmit={handleSubmit}
        moduleContentUsageId={moduleContentUsageId}
        hideReferenceKinds={["upload", "web_search"]}
      />
    </div>
  )

  async function handleSubmit(context: GenerateContentWithAISubmitProps) {
    if (context.prompt.length < 20) {
      displayErrorToast("Prompt should be a minimum of 20 characters")
    } else {
      await onSubmit(context)
    }
  }
}

const useStyles = makeUseStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
  },
}))

export default observer(GenerateContentWithAI)
